export enum SuggestType {
    userSuggest = 'user',
    assignTeamSuggest = 'team'
}

export enum AssignedTeamMemberType {
    User = 'User',
    Group = 'Group',
    Others = 'Others'
}


export enum AssignedTeamMemberTypeId {
    User = 1,
    Group,
    Others
}